<div class="sam-margin" fxLayout="row" fxLayoutAlign="flex-end center">
   <label class="centered">{{ 'common.system_monitoring.extended_mode' | translate }}</label>
   <kendo-switch class="sam-margin-left" [(ngModel)]="isExtendedMode"></kendo-switch>
</div>

<div class="sam-margin" kendoTooltip>
   <div class="status-row status-summary">
      <label fxFlex="1 1 30%">{{ 'common.system_monitoring.general_status' | translate }}</label>
      <samweb-system-monitor-status-icon
         fxFlex="1 1 70%"
         [isStatusOk]="isCommunicationHealthy$ | async"
      ></samweb-system-monitor-status-icon>
   </div>

   <div class="status-row" *ngIf="isExtendedMode">
      <label fxFlex="1 1 30%">{{ 'common.system_monitoring.samweb_sessions' | translate }}</label>
      <ul fxFlex="1 1 70%">
         <li *ngFor="let session of sessionInfos$ | async">
            <fa-icon
               class="sam-margin-left"
               [fixedWidth]="true"
               [icon]="session.sessionId === (sessionId$ | async) ? inUseIcon : notInUseIcon"
               [title]="
                  (session.sessionId === (sessionId$ | async)
                     ? 'common.system_monitoring.connection_status.active'
                     : 'common.system_monitoring.connection_status.not_active'
                  ) | translate
               "
            >
            </fa-icon>
            <fa-icon
               class="sam-margin-left"
               [fixedWidth]="true"
               [icon]="session.sessionType.icon"
               [title]="session.sessionType.nameTranslationKey | translate"
               [style.color]="session.sessionType.color"
            >
            </fa-icon>
            <div class="sam-margin-left" style="display: inline-table">
               <div>
                  <label>{{ 'common.system_monitoring.session_id' | translate }}</label> {{ session.sessionId }}
               </div>
               <div>
                  <label>{{ 'common.system_monitoring.connections' | translate }}</label>
                  {{ session.availableRealtimeConnections }}
               </div>
            </div>
         </li>
      </ul>
   </div>

   <div class="status-row">
      <label fxFlex="1 1 30%">{{ 'common.system_monitoring.real_time_status' | translate }}</label>
      <samweb-system-monitor-status-icon
         [isStatusOk]="isRealTimeConnectionHealthy$ | async"
      ></samweb-system-monitor-status-icon>
      <span *ngIf="isExtendedMode">{{ signalRConnectionId$ | async }}</span>
   </div>

   <div class="status-row status-summary" *ngIf="isExtendedMode"></div>

   <div class="status-row">
      <label fxFlex="1 1 30%">{{ 'common.system_monitoring.sccs1_connection' | translate }}</label>
      <samweb-system-monitor-status-icon
         [isStatusOk]="isSccs1ConnectionHealthy$ | async"
      ></samweb-system-monitor-status-icon>
      <span *ngIf="isExtendedMode">{{ sccs1SessionId$ | async }}</span>
   </div>

   <div class="status-row" *ngIf="isExtendedMode">
      <label fxFlex="1 1 30%">{{ 'common.system_monitoring.sccs1_status' | translate }}</label>
      <fa-icon class="sam-margin-left" *ngIf="isPreventSwitchOverActive$ | async" [icon]="keyIcon"></fa-icon>
      <ul fxFlex="1 1 70%">
         <li *ngFor="let connection of sccs1Connections$ | async">
            <samweb-system-monitor-status-icon
               [isStatusOk]="connection.isAvailable"
            ></samweb-system-monitor-status-icon>
            <fa-icon
               class="sam-margin-left"
               [fixedWidth]="true"
               [icon]="
                  (getConnectionWithSuccessfulLogons$ | async).includes(connection.name)
                     ? loggedOnIcon
                     : notLoggedOnIcon
               "
               [title]="
                  ((getConnectionWithSuccessfulLogons$ | async).includes(connection.name)
                     ? 'common.system_monitoring.sccs1_logon_status.logged_on'
                     : 'common.system_monitoring.sccs1_logon_status.not_logged_on'
                  ) | translate
               "
            ></fa-icon>
            <fa-icon
               class="sam-margin-left"
               [fixedWidth]="true"
               [icon]="connection.name === (sccs1ConnectionInUse$ | async) ? inUseIcon : notInUseIcon"
               [title]="
                  (connection.name === (sccs1ConnectionInUse$ | async)
                     ? 'common.system_monitoring.connection_status.active'
                     : 'common.system_monitoring.connection_status.not_active'
                  ) | translate
               "
            ></fa-icon>
            {{ connection.name }}
         </li>
      </ul>
   </div>

   <div class="status-row status-summary" *ngIf="isExtendedMode"></div>

   <div class="status-row" *ngIf="isExtendedMode">
      <label fxFlex="1 1 30%">{{ 'common.system_monitoring.connected_webapi' | translate }}</label>
      <span fxFlex="1 1 70%">{{ connectedWebApiServer$ | async }}</span>
   </div>

   <div class="status-row">
      <label fxFlex="1 1 30%">{{ 'common.system_monitoring.wepapi_version' | translate }}</label>
      <ng-container fxFlex="1 1 70%" *ngIf="!isExtendedMode">
         {{ (webApiVersion$ | async)?.semVer }}
      </ng-container>
      <ng-container fxFlex="1 1 70%" *ngIf="isExtendedMode">
         {{ (webApiVersion$ | async)?.informationalVersion }}
      </ng-container>
   </div>

   <div class="status-row status-summary" *ngIf="isExtendedMode"></div>

   <div class="status-row" *ngIf="isExtendedMode">
      <label fxFlex="1 1 30%">{{ 'common.system_monitoring.responsible_server' | translate }}</label>
      <span fxFlex="1 1 70%">{{ responsibleServer$ | async }}</span>
   </div>

   <div class="status-row">
      <label fxFlex="1 1 30%">{{ 'common.system_monitoring.user_version' | translate }}</label>
      <ng-container fxFlex="1 1 70%" *ngIf="!isExtendedMode">
         {{ (userVersion$ | async)?.semVer }}
      </ng-container>
      <ng-container fxFlex="1 1 70%" *ngIf="isExtendedMode">
         {{ (userVersion$ | async)?.informationalVersion }}
      </ng-container>
   </div>

   <div class="status-row status-summary" *ngIf="isExtendedMode"></div>

   <div class="status-row" *ngIf="isExtendedMode">
      <label fxFlex="1 1 30%">{{ 'common.system_monitoring.new_version_available' | translate }}</label>
      {{ ((isNewVersionAvailable$ | async) ? 'common.yes' : 'common.no') | translate }}
   </div>

   <div class="status-row">
      <label fxFlex="1 1 30%" class="centered">{{ 'common.system_monitoring.client_version' | translate }}</label>
      <ng-container *ngIf="!isExtendedMode">
         {{ clientVersion.semVer }}
      </ng-container>
      <ng-container *ngIf="isExtendedMode">
         {{ clientVersion.informationalVersion }}
      </ng-container>
   </div>
</div>
